var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConcept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 10.653c0-3.272-2.172-6.032-5.14-6.888m-9.04 6.888c0-3.465 2.435-6.355 5.672-7.019",
    stroke: "#009292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.182 1.952a1.318 1.318 0 1 0 0 2.637 1.318 1.318 0 0 0 0-2.637zM.864 3.271a2.318 2.318 0 0 1 4.582-.5h3.918v1H5.446a2.32 2.32 0 0 1-4.582-.5zm15.69.5h-3.918v-1h3.918a2.319 2.319 0 1 1 0 1zm.946-.5a1.318 1.318 0 1 1 2.636 0 1.318 1.318 0 0 1-2.636 0z",
    fill: "#009292"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.364,
    y: 1.816,
    width: 3.273,
    height: 3.273,
    rx: 0.364,
    stroke: "#009292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.352 7.516a.364.364 0 0 1 .573-.329l8.06 5.714a.364.364 0 0 1-.205.66l-4.332.07a.364.364 0 0 0-.305.175L9.9 17.513a.364.364 0 0 1-.674-.156l-.875-9.84z",
    fill: "#009292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcept);
export default __webpack_public_path__ + "static/media/concept.fb739945baf6d2b7947fa7c41e3224bf.svg";
export { ForwardRef as ReactComponent };